import React from "react";
import RichTreeViewControl from "../Controls/RichTreeViewControl";

type WorkspaceSelectorProps = {
  show: boolean;
  list: any[];
  parentId: string;
  onClose: () => void;
  onProceed: (selectedWorkspaceID: string, list: any[]) => void;
};

const WorkspaceSelector = ({
  show,
  list,
  parentId,
  onClose,
  onProceed,
}: WorkspaceSelectorProps) => {
  if (!show) return null;

  return (
    <RichTreeViewControl
      currentWorkspace={parentId}
      proceedButtonName="Save"
      list={list}
      title="Select a Workspace"
      showInPopup={show}
      handleCloseButtonClick={onClose}
      handleProceedButtonClick={onProceed}
    />
  );
};

export default WorkspaceSelector;
